module.exports = __webpack_public_path__ + "static/icons/icon-mastercard-logo.4eee805.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-tarjeta-credito/icon-mastercard-logo.svg
// module id = phq3
// module chunks = 1